import { useEffect, useRef } from "react";

const EditableSelect = (props) => {
  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  return (
    props.visible && (
      <div
        ref={popupref}
        className={`w-[250px] bg-white border border-gray-300 rounded-md overflow-y-scroll gk-scr p-[10px] absolute z-50 top-[50px] left-[0px] self-start`}
        style={props.style}
      >
        <div className="w-full overflow-y-scroll max-h-[120px]">
          {props.status.map((item, index) => (
            <div
              onClick={() => {
                props.onClickcorrect(item);
              }}
              className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:px-[10px] hover:rounded-xl`}
            >
              <p className=" font-medium PoppinsRegular text-sm ml-[10px]">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default EditableSelect;
